import {applyMiddleware, compose, createStore} from "redux";
import thunk from "redux-thunk";

import freshpaintReducer from "../reducers";

const reduxMiddleware = compose(
    applyMiddleware(thunk),
    // @ts-ignore
    window && window.devToolsExtension ? window.devToolsExtension() : (f) => f
);

export const store = createStore(freshpaintReducer, reduxMiddleware);
export type StoreState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch